import { render, staticRenderFns } from "./NeedsSubscription.vue?vue&type=template&id=2f463682"
import script from "./NeedsSubscription.vue?vue&type=script&lang=js"
export * from "./NeedsSubscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports